import { Icon, Tooltip } from "@blueprintjs/core"

export const ErrorIconWithTooltip = ({ errorMessage }: { errorMessage?: string }) => {
  return (
    <Tooltip content={errorMessage} placement="bottom" openOnTargetFocus={false} compact>
      <Icon icon="error" size={20} intent="warning" />
    </Tooltip>
  )
}
